import getters from './getters'
import actions from './actions'
import mutations from './mutations'

const state = {
    activeTab: 'details',
    displayModal: {
        ccloneCreation: false,
        cclonedelete: false,
        events: false
    },
    isEditing: false,
    selectedRowId: null,
    formAction: null,
    eventType: null,
    selectedEvents: {
        positive: null,
        negative: null,
        database: true
    },
    formulaVolumes: null,
    firstPartySelection: [],
    firstPartySelectAll: {},
    criteriaTypes: {
        positive: { current: null, previous: null },
        negative: { current: null, previous: null }
    },
    selectedCcloneId: null
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
